import styles from "./form-fields-panel.module.scss";
import { classNames as cx } from "primereact/utils";

type FormFieldsPanelProps = {
  label?: string;
  children: any;
  className?: string;
};

export const FormFieldsPanel = ({
  label,
  children,
  className,
}: FormFieldsPanelProps) => {
  return (
    <div className={cx(styles.panel, className)}>
      <h4>{label}</h4>
      {children}
    </div>
  );
};
